import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import { cargarCatalogosBodegaPrincipales } from '../../funciones_globales/catalogos';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';
// import global_axios  from '../../funciones_globales/interaccionapi';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import styled from 'styled-components';
import global_axios from '../../funciones_globales/interaccionapi';
import { getItemDatosSesion } from '../../funciones_globales/manejosesion';
const LabelCabecera = styled.label`
  display: inline;
  font-size: 9px;
  color: green;
  margin-right: 15px;
  float: right;
`;
const PaginationLabels = styled.div`
    font-size: 12px;
`;

const PaginationButtons = styled.div`
    margin-bottom:10px;
`;

const ButtonUnion = styled.button`
    height: 25px;
    padding: 0px 10px;
    font-size: 11px;
    z-index: 0;
`;
class FormVen25 extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            //Reporte
            Usuario :'',
            orden_numero:'',
            articulos:[],
            bodegas: [],
            titulos:[],
            soloTransito:false,
            bodega_sel: undefined,
            columnDefs: [
                {   header: "Bodega Origen",
                    field: "Bodega",
                    width: 200,
                    type: "string"
                },
                {   header: "Artículo",
                    field: "Articulo",
                    width: 150,
                    type: "string"
                }, 
                {   header: "Proforma",
                    field: "Pedido",
                    width: 100,
                    type: "string"
                }, 
                {   header: "Cantidad",
                    field: "Cantidad",
                    width: 105,
                    type: "num_entero"
                }                                                   
            ],
            pagination: {
                totalFilas: 0,
                totalFilasPorPagina: 0,
                primaraFilaPagina: 0,
                ultimaFilaPagina: 0,
            }, 
            
            //Reporte
           
           
        };
        this.gridOptions = {
            enableColResize: true,
            enableSorting: true,
            enableFilter: true,
            rowSelection: "single",
            suppressScrollOnNewData: true,
            paginationAutoPageSize:true,
            pagination: true,
            suppressPaginationPanel: true,
          onRowDoubleClicked: event => {
            let pedido = event.data;
            //this.getAsientoById(movimiento);
            this.cargarPedidoModificar(pedido) 
          },
          onPaginationChanged: () => {
            if(!this.api){
                return;
            }
            let totalFilas = this.api.paginationGetRowCount();
            let totalFilasPorPagina = this.api.paginationGetPageSize();
            let ultimaFilaPagina = (totalFilasPorPagina * (this.api.paginationGetCurrentPage()+1));
            let indexPage = this.api.paginationGetCurrentPage();
    
            if( ultimaFilaPagina >  totalFilas){
                ultimaFilaPagina = totalFilas;
            }
       
            let pagination = {
                totalFilas: totalFilas,
                totalFilasPorPagina: totalFilasPorPagina,
                primaraFilaPagina: (totalFilasPorPagina * (indexPage + 1) - totalFilasPorPagina + 1),
                ultimaFilaPagina: ultimaFilaPagina
            };
           
            this.setState({pagination});
          },
        };
        this.cargarArticulos = this.cargarArticulos.bind(this);
        this.onGridReady = this.onGridReady.bind(this);   
        this.limpiar = this.limpiar.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.generarOrdenTransferencia = this.generarOrdenTransferencia.bind(this)

    }
    generarOrdenTransferenciaAntigua(){
          var RespuestaInicial= prompt("Ingrese el numero de orden del cual se desea generar el reporte.");
          var OrdenNumero = parseInt(RespuestaInicial,10);
          console.log(RespuestaInicial)
          //PROCESO PARA MOSTRAR EL REPORTE.
          if(!isNaN(OrdenNumero)){
            let urlReportWithParams="";
            urlReportWithParams += `&param1=${OrdenNumero}`;
            urlReportWithParams =`&rpt=123`.concat(urlReportWithParams);
            visualizarReporteEnPdf(urlReportWithParams);
          }else{
              if(RespuestaInicial!==null && RespuestaInicial!==''){
                alert('Ingrese un numero de orden valido')
              }
              
          }
          
    }
    generarOrdenTransferencia(){
        if(this.state.bodega_sel!==undefined && this.state.bodega_sel!==null){
            //se procede a actualizar la tabla pedido para asignar un numero de orden a todos los pedidos de la consulta.
            let enTransito =this.state.soloTransito?'S':'N';
            this.props.cambiar_VisualizacionLoading(true)
            global_axios({
                method: 'POST',
                url: 'proformas/pedidos/modificar_numero_orden',
                data:{bodega:this.state.bodega_sel,
                      enTransito: enTransito,
                      articulos:this.state.articulos,
                      Usuario:this.state.Usuario
                }
            }).then( respuesta => {
                console.log(respuesta)
                var OrdenNumero= respuesta.data.OrdenNumero;
                //Se procede a cargar nuevamente los valores iniciales del formulario
                this.limpiar()
                global_axios({
                    method: 'GET',
                    url: '/secuenciales/OrdenNumero'
                }).then( response => {         
                    let cod_secuencial = response.data.codigo;      
                    this.setState({orden_numero:cod_secuencial})        
                    global_axios({
                        method: 'GET',
                        url: '/proformas/pedidos/iniciales/cantidades'
                    }).then( respuesta => {  
                        let arrayTitulos=[];
                        for(let k = 0; k < respuesta.data.length; k++){
                            let titulo= <LabelForm color='green' key={k}>Bodega: {respuesta.data[k].Descripcion +' : ' +respuesta.data[k].Cantidad+'  '}</LabelForm>;
                            arrayTitulos.push(<br  key={'k'+k}/>)
                            arrayTitulos.push(titulo)
                        }
                        this.setState({titulos:arrayTitulos})
                        //PROCESO PARA MOSTRAR EL REPORTE.
                        let urlReportWithParams="";
                        urlReportWithParams += `&param1=${OrdenNumero}`;
                        urlReportWithParams =`&rpt=123`.concat(urlReportWithParams);
                        visualizarReporteEnPdf(urlReportWithParams);
                        this.props.cambiar_VisualizacionLoading(false);
                    }).catch(error=>{
                        this.props.cambiar_VisualizacionLoading(false);
                        alert(`Ha ocurrido un error: ${error.response?error.response.data.msg:error.message}`);  	
                    });                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     
                })
                .catch(error=>{
                  this.props.cambiar_VisualizacionLoading(false);
                  alert(`Ha ocurrido un error: ${error.response?error.response.data.msg:error.message}`);  	
                });
                this.props.cambiar_VisualizacionLoading(false);
            }).catch(error=>{
                this.props.cambiar_VisualizacionLoading(false);
                alert(`Ha ocurrido un error: ${error.response?error.response.data.msg:error.message}`);  	
            });       
        }else{
            alert('Debe seleccionar una bodega')
        }
    }
    onGridReady(params) {
        this.api = params.api;
        this.columnApi = params.columnApi;
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
    
        this.setState({
          [name]: value
        });
    }

   
    componentDidMount(){
        Promise.all([
            cargarCatalogosBodegaPrincipales('BODEGA'),
            getItemDatosSesion('usuario'),
            this.props.generar_LogAuditoriaIngresoForm('0425')
         ])
        .then(([result_bodegas,usuario ]) => { 
            this.setState({bodegas: result_bodegas, Usuario:usuario})
            global_axios({
                method: 'GET',
                url: '/secuenciales/OrdenNumero'
            }).then( response => {         
                let cod_secuencial = response.data.codigo;      
                this.setState({orden_numero:cod_secuencial})        
                this.props.cambiar_VisualizacionLoading(true);  
                global_axios({
                    method: 'GET',
                    url: '/proformas/pedidos/iniciales/cantidades'
                }).then( respuesta => {  
                    let arrayTitulos=[];
                    for(let k = 0; k < respuesta.data.length; k++){
                        let titulo= <LabelForm color='green' key={k}>Bodega: {respuesta.data[k].Descripcion +' : ' +respuesta.data[k].Cantidad+'  '}</LabelForm>;
                        arrayTitulos.push(<br  key={'k'+k}/>)
                        arrayTitulos.push(titulo)
                    }
                    this.setState({titulos:arrayTitulos})
                    this.props.cambiar_VisualizacionLoading(false);
                }).catch(error=>{
                    this.props.cambiar_VisualizacionLoading(false);
                    alert(`Ha ocurrido un error: ${error.response?error.response.data.msg:error.message}`);  	
                });                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     
            })
            .catch(error=>{
              this.props.cambiar_VisualizacionLoading(false);
              alert(`Ha ocurrido un error: ${error.response?error.response.data.msg:error.message}`);  	
            });
      
        })
        .catch(error=>{
            alert(error);
        });
    }
    compare( a, b ) {
        if ( a.CodigoBodega < b.CodigoBodega ){
          return -1;
        }
        if ( a.CodigoBodega > b.CodigoBodega ){
          return 1;
        }
        return 0;
      }
    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0425');
    }
    cargarArticulos(){
        if(this.state.bodega_sel!==undefined && this.state.bodega_sel!==null){
            this.props.cambiar_VisualizacionLoading(true);  
            let enTransito =this.state.soloTransito?'S':'N';
            let query = "?bodega="+this.state.bodega_sel+"&enTransito="+enTransito
            
            global_axios({
                method: 'GET',
                url: '/proformas/pedidos/iniciales/orden'+query
            }).then( response => {
                let proformas=response.data;
                this.setState({articulos:proformas});
                this.props.cambiar_VisualizacionLoading(false);
                
            }).catch(error=>{
                this.props.cambiar_VisualizacionLoading(false);
                alert(`Ha ocurrido un error: ${error.response?error.response.data.msg:error.message}`);  	
            });
        }else{
            alert('Debe seleccionar una bodega')
        }
    }
    limpiar(){         
        this.setState({ 
        soloTransito:false,
        bodega_sel: undefined,
        articulos:[]});
    }

    render(){ 
        return (
            <ContenedorForm porc_ancho={55}>
            <HeaderForm>
                <TituloForm>Orden de Transferencias a Retirar</TituloForm>
                
                <LabelCabecera>Orden N: {this.state.orden_numero}</LabelCabecera> 
            </HeaderForm>
                <CuerpoForm>
                <Row>
                    <ContainerCol className='col-xs-6 col-sm-6'>
                        <LabelForm>Resumen de items</LabelForm>
                        {
                            this.state.titulos
                        }
                    </ContainerCol>
                    <ContainerCol className='col-sm-4' margen_arriba='15' margen_abajo='4'>
                        <LabelForm>Bodega:</LabelForm>
                        <ReactSelect  options={ this.state.bodegas } value={this.state.bodega_sel} func_onChange={(value)=>{this.setState({bodega_sel: value!==null?value.value:null})}}/>
                    </ContainerCol>
                    <ContainerCol className='col-sm-2' margen_arriba='30' >
                        <div className='input-group'>
                            <span className='input-group-btn'>
                                <ButtonUnion type='button' className='btn btn-success btn-sm' onClick={this.cargarArticulos}><i className='fa fa-search'></i> Buscar</ButtonUnion>                
                            </span>
                        </div>
                    </ContainerCol> 
                </Row>
                <Row>
                    <ContainerCol className='col-sm-4 col-sm-offset-1 col-sm-pull-1' margen_arriba='15' margen_abajo='4'>
                        <LabelForm><input type='checkbox' name='soloTransito' checked={this.state.soloTransito} 
                        onChange={this.handleInputChange}/> Solo artículos en transito</LabelForm> 
                    </ContainerCol>
                </Row>
                <Row>
                  <ContainerCol className='col-xs-12 col-sm-12' align="center">
                    <h4><strong>Artículos</strong></h4>
                  </ContainerCol>
                </Row>
                <div className='col-md-12'>   
                    <AgGridRender altura='200px' data={this.state.articulos} columnas={this.state.columnDefs}
                    gridOptions={this.gridOptions} onGridReady={this.onGridReady}/>
                </div>
                <div className="col-xs-12 col-sm-12">
                    <Row>
                        <ContainerCol className="col-xs-12 col-sm-12">
                            <PaginationLabels>
                                {this.state.pagination.primaraFilaPagina} a {this.state.pagination.ultimaFilaPagina} de {this.state.pagination.totalFilas}
                            </PaginationLabels>
                            <PaginationButtons>
                                <div className="btn-group btn-group-xs" role="group">
                                    <button style={{height:'30px'}} type="button" className="btn btn-default" onClick={() => this.api.paginationGoToFirstPage()}>
                                        <i className="fa fa-angle-double-left fa-fw"></i>Ir al inicio
                                    </button>
                                    <button style={{height:'30px'}} type="button" className="btn btn-default" onClick={() => this.api.paginationGoToPreviousPage()}>
                                        <i className="fa fa-angle-left fa-fw"></i>Anterior
                                    </button>
                                    <button style={{height:'30px'}} type="button" className="btn btn-default" onClick={() => this.api.paginationGoToNextPage()}>
                                        Siguiente<i className="fa fa-angle-right fa-fw"></i>
                                    </button>
                                    <button style={{height:'30px'}} type="button" className="btn btn-default" onClick={() => this.api.paginationGoToLastPage()}>
                                        Ir al final<i className="fa fa-angle-double-right fa-fw"></i>
                                    </button>
                                </div>
                            </PaginationButtons>
                        </ContainerCol>
                    </Row>
                </div>
                <Row margen_arriba={10}>
                    <ContainerCol className='col-sm-12'>
                        <div className='btn-group pull-right'>       
                            <button type='button' className='btn btn-success btn-sm' onClick={this.generarOrdenTransferenciaAntigua}><i className="fa fa-print fa-lg" aria-hidden="true"/> Generar Orden antigua.</button>                       
                            <button type='button' className='btn btn-info btn-sm' onClick={this.generarOrdenTransferencia}><i className="fa fa-print fa-lg" aria-hidden="true"/> Generar</button>  
                            <button type="button" className='btn btn-sm'  onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>
                        </div>
                    </ContainerCol>
                </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
} 

const mapStateToProps = ((state) => {
    return { fechaProceso: state.sesion.valoresSesionForm.FechaProceso,tipoUsuario: state.sesion.valoresSesionForm.TipoUsuario }
});

const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm, cambiar_VisualizacionLoading}, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(FormVen25);